import { Box, Button, Typography } from "@luce/ui";

import { ConfirmDeleteModal } from "./components/confirm-delete-modal";
import { DeleteAccountOtpModal } from "./components/delete-account-otp-modal";
import { DeleteSucceedModal } from "./components/delete-succeed-modal";
import { DeleteAccountContext, useDeleteAccountContext } from "./delete-account-context";
import { useDeleteAccount } from "./use-delete-account";

function DeleteAccountCard() {
  const { step, phoneNumber, isSendingOtp, start } = useDeleteAccountContext();

  return (
    <Box className="gap-spacing-md p-spacing-md rounded-radius-lg border-luce-system-danger-border bg-luce-system-danger-surface flex flex-col border md:flex-row md:items-center">
      <Box className="gap-spacing-xs flex flex-col md:flex-1">
        <Typography variant="body-md" color="system-danger-on-surface">
          Delete your Data and Account
        </Typography>
        <Typography variant="body-sm" color="system-danger-on-surface">
          Are you sure you want to delete your account? After deleting your account, you will not be
          able to login anymore.
        </Typography>
      </Box>
      <Button
        variant="destructive"
        size="md"
        label="Delete Account"
        loading={step === "idle" && isSendingOtp}
        disabled={!phoneNumber}
        onClick={start}
      />
    </Box>
  );
}

export function AccountInfoDeleteAccount() {
  const value = useDeleteAccount();

  return (
    <DeleteAccountContext.Provider value={value}>
      <DeleteAccountCard />
      <DeleteAccountOtpModal />
      <ConfirmDeleteModal />
      <DeleteSucceedModal />
    </DeleteAccountContext.Provider>
  );
}
